import { CreatorStoriesHeroSectionPropType } from "@/components/CreatorStories/CreatorStoriesHeroSection";
import { FeatureCTASectionPropType } from "@/components/Features/FeatureCTASection";
import { ButtonSizeEnum, ButtonTypeEnum } from "@/components/atoms/Button";
import {
  CtaActionType,
  SignUpSourceEnum,
} from "@/components/molecules/CtaButtonGroup";
import { GraphyHeadPropType } from "@/components/organisms/GraphyHead";
import { LANDING_PAGE_EVENTS } from "@/constants/amplitude.constants";
import { ASSETS_LINK } from "../../../constant";
import {
  CreatorCategoryEnum,
  FeaturePageSlugEnum,
  ProductPageSlugEnum,
} from "../types/common.types";
import { HeroPillCategoryEnum_en } from "./hero-pills.data";
import { ROUTE_PATHS } from "./routes";

export type CreatorStoriesPageDataType = {
  seoMeta: GraphyHeadPropType;
  creatorStoriesHeroSectionProps: CreatorStoriesHeroSectionPropType;
  featureCTASectionProps: FeatureCTASectionPropType;
};

const successStories = [
  // {
  //   name: "Abhijit Chavda",
  //   category: CreatorCategoryEnum.Academics,
  //   description:
  //     "Graphy is the best way to launch your courses! One of the biggest USPs of the product is how robust & flexible it is: support in international markets & flexibility with content delivery.",
  //   designation: "Founder",
  //   company: "Abhijit Chavda Academy",
  //   highlight: {
  //     main: "664K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/abhijitchavda7460_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/abhijitchavda7460_image.jpg`,
  //   href: "https://www.achavda.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.WebsiteBuilder]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.MobileApp]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.MarketingTools]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  {
    name: "Arijit Saha",
    category: CreatorCategoryEnum.Music,
    description:
      "I've tried several platforms, but Graphy stands out from the rest. The intuitive interface, robust features, & overall user experience make it my top choice for selling courses online.",
    designation: "Artist",
    company: "Better Musician Everyday",
    highlight: {
      main: "43.6K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/arijitsaha_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/arijitsaha_image.jpg`,
    href: "https://arijitsaha.graphy.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.webinar]: {
          testimony: true,
          stories: false,
        },
      },
      features: {
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Paul Uduk",
    category: CreatorCategoryEnum.Academics,
    description:
      "I've been promoting Graphy for about 2 months. So far I've referred 29 friends who have opened Graphy accounts.",
    designation: "Trainer",
    company: "iSchool",
    highlight: {
      main: "20K",
      subtext: "Students trained",
    },
    avatar: `${ASSETS_LINK}/graphy-web/pauluduk7755_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/pauluduk7755_image.jpg`,
    href: "https://coachpaulcourses.pauluduk.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.aiavatar]: {
          testimony: true,
          stories: false,
        },
       
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.IntegratePaymentGateway]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Jash",
    category: CreatorCategoryEnum.Music,
    description:
      "Graphy has the easiest interface which makes our courses very easy to watch for users and easy for us to list courses. Graphy has empowered us to monetize our content in the most easiest manner possible.",
    designation: "Musician",
    company: "Pix Series",
    highlight: {
      main: "106K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/jashgotawala1750_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/jashgotawala1750_image.jpg`,
    href: "https://course.pixseries.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.membership]: {
          testimony: true,
          stories: false,
        },
      },
      features: {
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.ThirdPartySupport]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: true, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  // {
  //   name: "Dr Madhab Nayak",
  //   category: CreatorCategoryEnum.Health,
  //   description:
  //     "Its a best Platform to show and monetize anyone who want to express their hidden talent to Public",
  //   designation: "Founder",
  //   company: "Dr Madhabs Medical School",
  //   highlight: {
  //     main: "2.5K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/drmadhabnayak2099_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/drmadhabnayak2099_image.jpg`,
  //   href: "https://drmadhabnayak2099.ongraphy.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.MarketingTools]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  {
    name: "Gaurav Sharma",
    category: CreatorCategoryEnum.Finance,
    description:
      "The interface of the platform is simple to navigate and provides a smooth experience to the learners as well. They are continously evolving and adding new features which keeps things exciting.",
    designation: "Advisor",
    company: "Simplifying Finance",
    highlight: {
      main: "100+",
      subtext: "students trained",
    },
    avatar: `${ASSETS_LINK}/graphy-web/gauravsharma3820_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/gauravsharma3820_image.jpg`,
    href: "https://gauravsharma3820.graphy.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.MarketingTools]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Zakirhusen Pinjari",
    category: CreatorCategoryEnum.Technology,
    description:
      "This graphy platform is very user friendly and easy to use so many features provided to develop our elearning coaching business. Thank you so much graphy for this wonderful platform",
    designation: "Manager",
    company: "Geniusecademy.com",
    highlight: {
      main: "10K+",
      subtext: "students taught",
    },
    avatar: `${ASSETS_LINK}/graphy-web/geniuselearninghub_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/geniuselearninghub_image.jpg`,
    href: "https://geniuselearninghub.spayee.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: true,
          stories: false,
        },
      },
      features: {
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Sunil Kargwal",
    category: CreatorCategoryEnum.Technology,
    description:
      "I've tried several platforms for teaching technology, and Graphy stands out for its user-friendly interface and rich features. Highly recommended.",
    designation: "Founder",
    company: "Graphics Guruji by Sunil Kargwal",
    highlight: {
      main: "62.8K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/sunilkargwal6794_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/sunilkargwal6794_image.jpg`,
    href: "https://graphicsguruji.ongraphy.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Shubham Londhe",
    category: CreatorCategoryEnum.Technology,
    description:
      "Graphy is a great feature-laden platform with an easy-to-use interface. It offers support for Live Classes and has an amazing Course Builder.",
    designation: "Creator",
    company: "Train with Shubham",
    highlight: {
      main: "52K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/shubhamlondhe9360_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/shubhamlondhe9360_image.jpg`,
    href: "https://www.trainwithshubham.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.aiavatar]: {
          testimony: true,
          stories: false,
        },
      
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Manil",
    category: CreatorCategoryEnum.Academics,
    description:
      "I want to thank team at Graphy for the amazing support that you have provided to me while selling courses online. I hope that this fruitful relationship will continue for many years to come",
    designation: "Founder",
    company: "Manil",
    highlight: {
      main: "100+",
      subtext: "Instagram followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/ieltsbymanil_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/ieltsbymanil_image.jpg`,
    href: "https://www.manil.co",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Rahul Devkar",
    category: CreatorCategoryEnum.Business,
    description:
      "Graphy helped me launch my business online! With their in-built live classes, I have taught 1500+ students in just one year. I have helped dozens of creators launch their courses online using Graphy.",
    designation: "Creator",
    company: "Business School for Creative Minds",
    highlight: {
      main: "800+",
      subtext: "LinkedIn followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/businessschool_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/businessschool_image.jpg`,
    href: "https://learn.rahuldevkar.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.aiavatar]: {
          testimony: false,
          stories: true,
        },
        
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Harsh Patel",
    category: CreatorCategoryEnum.Finance,
    description:
      "It's easy and save cost, friendly response from graphy, however more customization options for app, text & section sizes can help",
    designation: "Creator",
    company: "Trade Maker's Academy",
    highlight: {
      main: "100+",
      subtext: "learners trained",
    },
    avatar: `${ASSETS_LINK}/graphy-web/harshpatel9620_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/harshpatel9620_image.jpg`,
    href: "https://harshpatel9620.ongraphy.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Shivashankar Gachinmath",
    category: CreatorCategoryEnum.Finance,
    description:
      "Graphy is the Best platform for creating courses, conducting online class,conducting online meetings, sales talks, etc its all in one platform , and user friendly",
    designation: "Trainer",
    company: "Shivashankar Gachinmath",
    highlight: {
      main: "100+",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/shivashankargachinmath0183_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/shivashankargachinmath0183_image.jpg`,
    href: "https://shivashankargachinmath0183.ongraphy.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.membership]: {
          testimony: true,
          stories: false,
        },
      },
      features: {
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Ceshkar",
    category: CreatorCategoryEnum.FinanceAndInvesting,
    description:
      "Beyond the exceptional staff!After encountering problems with Kajabi, we needed a new platform FAST, and one that would allow us to represent who we are as a company. The website design is sleek and intuitive, making it a breeze to navigate.",
    designation: "Real estate mastery",
    company: "Ceshkar Group",
    highlight: {
      main: "2k+",
      subtext: "Facebook followers",
    },
    avatar: `https://d502jbuhuh9wk.cloudfront.net/logos/6635015fca139e6991a897b4.png`,
    image: `${ASSETS_LINK}/graphy-web/nitinmodi2401_image.jpg`,
    href: "https://tomceshker.graphy.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.IntegratePaymentGateway]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Laurel Archer",
    category: CreatorCategoryEnum.Academics,
    description:
      "I like all the options it has for Design, Marketing, and for selling Courses - I am excited about sharing my new home to the world.",
    designation: "Founder",
    company: "Laurel's Learning Lab",
    highlight: {
      main: "575",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/laurelarcher4128_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/laurelarcher4128_image.jpg`,
    href: "https://www.laurelslearninglab.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.aiavatar]: {
          testimony: false,
          stories: true,
        },
       
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.IntegratePaymentGateway]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Raghuram Natesan",
    category: CreatorCategoryEnum.Technology,
    description:
      "I believe that the features offered by Graphy are conducive to create a powerful learning experience.",
    designation: "Founder",
    company: "LifeSparsh",
    highlight: {
      main: "100+",
      subtext: "Instagram followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/raghuramnatesan_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/raghuramnatesan_image.jpg`,
    href: "https://www.lifesparsh.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.ThirdPartySupport]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Ebenezer Mamabolo",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
      "Its the best platform. Very simple and easy to master. Plus great support from the support team. I love Graphy.",
    designation: "Creator",
    company: "Monetizing Purpose",
    highlight: {
      main: "728",
      subtext: "Instagram followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/ebenezer2058_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/ebenezer2058_image.jpg`,
    href: "https://www.ebenezermamabolo.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: true,
          stories: false,
        },
      },
      features: {

      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Madhura Rajagopalan",
    category: CreatorCategoryEnum.Health,
    description:
      "It's affordable, user-friendly, has excellent backend support from the technical staff & gives a lot of control in the hands of the website owner to design the layout etc.",
    designation: "Yoga Coach",
    company: "Yoga with Madhura",
    highlight: {
      main: "380+",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/madhurarajagopalan9169_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/madhurarajagopalan9169_image.jpg`,
    href: "https://www.yogawithmadhura.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: true,
          stories: false,
        },
      },
      features: {
        [FeaturePageSlugEnum.WebsiteBuilder]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.IntegratePaymentGateway]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Sanjay Thakur",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
      "A Complete package ideal for selling courses online, be it for school/college students or corporate executives and business owners.",
    designation: "Coach",
    company: "Master Koach",
    highlight: {
      main: "10K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/mkanak1933_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/mkanak1933_image.jpg`,
    href: "https://learning.masterkoach.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.webinar]: {
          testimony: true,
          stories: false,
        },
      },
      features: {
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Nikhil Raibole",
    category: CreatorCategoryEnum.Business,
    description:
      "Graphy revolutionized my online business. Easy website creation, powerful marketing tools, seamless payment integration.",
    designation: "Founder",
    company: "GetInspire",
    highlight: {
      main: "800+",
      subtext: "Instagram followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/nikhilraibole4800_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/nikhilraibole4800_image.jpg`,
    href: "https://nikhilraibole4800.graphy.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.membership]: {
          testimony: true,
          stories: false,
        },
      },
      features: {
        [FeaturePageSlugEnum.IntegratePaymentGateway]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.MarketingTools]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Niladri Bihari",
    category: CreatorCategoryEnum.Other,
    description: `I was looking for a Digital Learning Platform for my Two Not-For-Profit initiatives but I didn't want to compromise on any of the advanced features of a modern LMS. Graphy was "THE" solution ticking all the checkboxes of our need.`,
    designation: "Trainer",
    company: "ISKCON Brahmapur",
    highlight: {
      main: "7K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/niladribiharinayak_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/niladribiharinayak_image.jpg`,
    href: "https://niladribiharinayak.graphy.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.membership]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.WebsiteBuilder]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Nishant Sharma",
    category: CreatorCategoryEnum.Business,
    description:
      "I like it very much there is always a scope for improvement, and I have been and will  continue to suggest the same",
    designation: "Founder",
    company: "Mentor Geeks",
    highlight: {
      main: "100+",
      subtext: "Linkedin followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/nishantsharma9432_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/nishantsharma9432_image.jpg`,
    href: "https://www.mentorgeeks.in",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.ThirdPartySupport]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.MarketingTools]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Sachin Rao",
    category: CreatorCategoryEnum.Academics,
    description:
      "I was trying to compare with other similar products and when I felt this was better for selling courses online, I took it up. The support was Excellent.",
    designation: "Coach",
    company: "Cricket Coach Online",
    highlight: {
      main: "200+",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/sachinrao6295_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/sachinrao6295_image.jpg`,
    href: "https://www.cricketcoachonline.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.WebsiteBuilder]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "CA Rachana Ranade",
    category: CreatorCategoryEnum.Finance,
    description:
      "I've been using Graphy since Day 1 of my entrepreneurial journey. Its because of Graphy that I'm able to offer my courses in India & internationally. The platform's global payment options & mobile apps enabled me to connect with students worldwide.",
    designation: "Founder",
    company: "Rachana Ranade",
    highlight: {
      main: "4.45M",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/carachana_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/carachana_image.jpg`,
    href: "https://www.rachanaranade.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.aiavatar]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.WebsiteBuilder]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Neeraj Arora",
    category: CreatorCategoryEnum.Business,
    description:
      "Graphy has got all the elements to make our Coaching & Online Courses business a success",
    designation: "Master Coach",
    company: "Skill91",
    highlight: {
      main: "800+ K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/skill91_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/skill91_image.jpg`,
    href: "https://www.skill91.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.aiavatar]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.ThirdPartySupport]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: true, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Kundan Kishore",
    category: CreatorCategoryEnum.Finance,
    description:
      "Graphy has all the features required to sell courses online and create a good learning platform",
    designation: "Founder",
    company: "Kundan Kishore",
    highlight: {
      main: "186K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/kundankishore_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/kundankishore_image.jpg`,
    href: "https://www.kundankishore.in",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: true,
          stories: false,
        },
      },
      features: {
        [FeaturePageSlugEnum.MarketingTools]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.WebsiteBuilder]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: true, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Love Babbar",
    category: CreatorCategoryEnum.Academics,
    description:
      "Graphy is a platform that is feature-rich whilst being easy to use. The tools provide me with a lot of control with regard to Referrals, Course Content, & Analytics. Graphy has been the perfect partner for us.",
    designation: "Founder",
    company: "Code Help",
    highlight: {
      main: "533K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/lovebabbar4318_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/lovebabbar4318_image.jpg`,
    href: "https://www.thecodehelp.in",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.WebsiteBuilder]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Niranjan P",
    category: CreatorCategoryEnum.Other,
    description:
      "I'm amazed by the impact Graphy has had on my business. The professional design options and seamless integration of multimedia content have taken my courses to the next level.",
    designation: "Creator",
    company: "Niru's Calligraphy",
    highlight: {
      main: "46K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/niruscalligraphy6003_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/niruscalligraphy6003_image.jpg`,
    href: "https://niruscalligraphycourses.graphy.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: true,
          stories: false,
        },
      },
      features: {
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.ThirdPartySupport]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Harnoor Singh",
    category: CreatorCategoryEnum.Academics,
    description:
      "The quickest way to launch and sell your course. Trust me on this, you will be running a thriving business in no time.",
    designation: "Founder",
    company: "Singh in USA",
    highlight: {
      main: "1.04M",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/harnoorsingh1547_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/harnoorsingh1547_image.jpg`,
    href: "https://singhinusa.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.MarketingTools]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Murali Sundaram",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
      "All I wanted was an app & membership feature to automate the process of onboarding students. Leaving me to focus on teaching without having to worry about the tech side of things. Graphy has given me just that.",
    designation: "Coach",
    company: "Unlimited Happyness",
    highlight: {
      main: "5.7K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/coachmurli_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/coachmurli_image.jpg`,
    href: "https://www.unlimitedhappyness.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.membership]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.ThirdPartySupport]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "CA Neha Datta",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
      "The platform's intuitive course builder, multimedia capabilities, and analytics have made creating immersive learning experiences effortless. Graphy is a game-changer for personal development courses.",
    designation: "Founder",
    company: "CA Neha Datta",
    highlight: {
      main: "150K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/canehadatta6479_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/canehadatta6479_image.jpg`,
    href: "https://canehadatta.ongraphy.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.membership]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.ThirdPartySupport]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Sanchit Kalra",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
      "Navigating through the platform and accessing its features is a breeze, even for someone who may not be tech-savvy.",
    designation: "Founder",
    company: "Be Your Best",
    highlight: {
      main: "538K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/sanchitkalra_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/sanchitkalra_image.jpg`,
    href: "https://sanchitkalra.ongraphy.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.ThirdPartySupport]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Sujata Dutta",
    category: CreatorCategoryEnum.Business,
    description:
      "Most user friendly platform that I have come across And loaded with features and benefits :)",
    designation: "Founder",
    company: "Designers Mastermind Hub",
    highlight: {
      main: "1.2K",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/sujatadutta4963_avatar.webp`,
    image: `${ASSETS_LINK}/graphy-web/sujatadutta4963_image.jpg`,
    href: "https://sujatadutta4963.spayee.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.MarketingTools]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Brooke Harris",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
      "My website looks like it was professionally designed and the courses are laid out beautifully and easy for users to interact with and understand. The Graphy team has been super helpful, responsive and patient while guiding me through this process and helping me get my site and business launched. I'm so grateful this exists.",
    designation: "CEO @ Goodmylk",
    company: "Expander's Club",
    highlight: {
      main: "4k+",
      subtext: "Instagram followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/brookeharris_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/nitinmodi2401_image.jpg`,
    href: "https://www.expandersclub.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Ankur Warikoo",
    category: CreatorCategoryEnum.Business,
    description:
      "Graphy is a truly all-in-one platform that covers every aspect of scaling my business seamlessly.",
    designation: "Founder",
    company: "WebVeda",
    highlight: {
      main: "5.78 M",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/webveda_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/webveda_image.png`,
    href: "https://webveda.com/",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.aiavatar]: {
          testimony: true,
          stories: true,
        },
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.ThirdPartySupport]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: true, // If it's false, we can skip the key also.
      stories: true,
    },
  },
];

const successStoriesUS = [
  // {
  //   name: "Abhijit Chavda",
  //   category: CreatorCategoryEnum.Academics,
  //   description:
  //     "Graphy is the best way to launch your courses! One of the biggest USPs of the product is how robust & flexible it is: support in international markets & flexibility with content delivery.",
  //   designation: "Founder",
  //   company: "Abhijit Chavda Academy",
  //   highlight: {
  //     main: "664K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/abhijitchavda7460_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/abhijitchavda7460_image.jpg`,
  //   href: "https://www.achavda.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.WebsiteBuilder]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.MobileApp]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.MarketingTools]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Arijit Saha",
  //   category: CreatorCategoryEnum.Music,
  //   description:
  //     "I've tried several platforms, but Graphy stands out from the rest. The intuitive interface, robust features, & overall user experience make it my top choice for selling courses online.",
  //   designation: "Artist",
  //   company: "Better Musician Everyday",
  //   highlight: {
  //     main: "43.6K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/arijitsaha_avatar.png`,
  //   image: `${ASSETS_LINK}/graphy-web/arijitsaha_image.jpg`,
  //   href: "https://arijitsaha.graphy.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.MobileApp]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.ChatCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.SecureVideoStreaming]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  {
    name: "Paul Uduk",
    category: CreatorCategoryEnum.Academics,
    description:
      "I've been promoting Graphy for about 2 months. So far I've referred 29 friends who have opened Graphy accounts.",
    designation: "Trainer",
    company: "iSchool",
    highlight: {
      main: "20K",
      subtext: "Students trained",
    },
    avatar: `${ASSETS_LINK}/graphy-web/pauluduk7755_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/pauluduk7755_image.jpg`,
    href: "https://coachpaulcourses.pauluduk.com",
    showOn: {
      home: false,
      products: {
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.aiavatar]: { 
          testimony: true,
          stories: true,
        },
       
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: { 
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.IntegratePaymentGateway]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  // {
  //   name: "Jash",
  //   category: CreatorCategoryEnum.Music,
  //   description:
  //     "Graphy has the easiest interface which makes our courses very easy to watch for users and easy for us to list courses. Graphy has empowered us to monetize our content in the most easiest manner possible.",
  //   designation: "Musician",
  //   company: "Pix Series",
  //   highlight: {
  //     main: "106K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/jashgotawala1750_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/jashgotawala1750_image.jpg`,
  //   href: "https://course.pixseries.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.MobileApp]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.ChatCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Dr Madhab Nayak",
  //   category: CreatorCategoryEnum.Health,
  //   description:
  //     "Its a best Platform to show and monetize anyone who want to express their hidden talent to Public",
  //   designation: "Founder",
  //   company: "Dr Madhabs Medical School",
  //   highlight: {
  //     main: "2.5K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/drmadhabnayak2099_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/drmadhabnayak2099_image.jpg`,
  //   href: "https://drmadhabnayak2099.ongraphy.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.MarketingTools]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Gaurav Sharma",
  //   category: CreatorCategoryEnum.Finance,
  //   description:
  //     "The interface of the platform is simple to navigate and provides a smooth experience to the learners as well. They are continously evolving and adding new features which keeps things exciting.",
  //   designation: "Advisor",
  //   company: "Simplifying Finance",
  //   highlight: {
  //     main: "100+",
  //     subtext: "students trained",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/gauravsharma3820_avatar.png`,
  //   image: `${ASSETS_LINK}/graphy-web/gauravsharma3820_image.jpg`,
  //   href: "https://gauravsharma3820.graphy.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.MarketingTools]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Zakirhusen Pinjari",
  //   category: CreatorCategoryEnum.Technology,
  //   description:
  //     "This graphy platform is very user friendly and easy to use so many features provided to develop our elearning coaching business. Thank you so much graphy for this wonderful platform",
  //   designation: "Manager",
  //   company: "Geniusecademy.com",
  //   highlight: {
  //     main: "10K+",
  //     subtext: "students taught",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/geniuselearninghub_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/geniuselearninghub_image.jpg`,
  //   href: "https://geniuselearninghub.spayee.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Sunil Kargwal",
  //   category: CreatorCategoryEnum.Technology,
  //   description:
  //     "I've tried several platforms for teaching technology, and Graphy stands out for its user-friendly interface and rich features. Highly recommended.",
  //   designation: "Founder",
  //   company: "Graphics Guruji by Sunil Kargwal",
  //   highlight: {
  //     main: "62.8K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/sunilkargwal6794_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/sunilkargwal6794_image.jpg`,
  //   href: "https://graphicsguruji.ongraphy.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.MobileApp]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Shubham Londhe",
  //   category: CreatorCategoryEnum.Technology,
  //   description:
  //     "Graphy is a great feature-laden platform with an easy-to-use interface. It offers support for Live Classes and has an amazing Course Builder.",
  //   designation: "Creator",
  //   company: "Train with Shubham",
  //   highlight: {
  //     main: "52K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/shubhamlondhe9360_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/shubhamlondhe9360_image.jpg`,
  //   href: "https://www.trainwithshubham.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.ChatCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.SecureVideoStreaming]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Manil",
  //   category: CreatorCategoryEnum.Academics,
  //   description:
  //     "I want to thank team at Graphy for the amazing support that you have provided to me while selling courses online. I hope that this fruitful relationship will continue for many years to come",
  //   designation: "Founder",
  //   company: "Manil",
  //   highlight: {
  //     main: "100+",
  //     subtext: "Instagram followers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/ieltsbymanil_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/ieltsbymanil_image.jpg`,
  //   href: "https://www.manil.co",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.SecureVideoStreaming]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Rahul Devkar",
  //   category: CreatorCategoryEnum.Business,
  //   description:
  //     "Graphy helped me launch my business online! With their inbuilt live classes i have taught 1500+ students in just one year. I have helped dozens of creators launch their courses online using graphy.",
  //   designation: "Creator",
  //   company: "Business School for Creative Minds",
  //   highlight: {
  //     main: "800+",
  //     subtext: "LinkedIn followers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/businessschool_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/businessschool_image.jpg`,
  //   href: "https://learn.rahuldevkar.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.SecureVideoStreaming]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Harsh Patel",
  //   category: CreatorCategoryEnum.Finance,
  //   description:
  //     "It's easy and save cost, friendly response from graphy, however more customization options for app, text & section sizes can help",
  //   designation: "Creator",
  //   company: "Trade Maker's Academy",
  //   highlight: {
  //     main: "100+",
  //     subtext: "learners trained",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/harshpatel9620_avatar.png`,
  //   image: `${ASSETS_LINK}/graphy-web/harshpatel9620_image.jpg`,
  //   href: "https://harshpatel9620.ongraphy.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Shivashankar Gachinmath",
  //   category: CreatorCategoryEnum.Finance,
  //   description:
  //     "Graphy is the Best platform for creating courses, conducting online class,conducting online meetings, sales talks, etc its all in one platform , and user friendly",
  //   designation: "Trainer",
  //   company: "Shivashankar Gachinmath",
  //   highlight: {
  //     main: "100+",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/shivashankargachinmath0183_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/shivashankargachinmath0183_image.jpg`,
  //   href: "https://shivashankargachinmath0183.ongraphy.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  {
    name: "Ceshkar",
    category: CreatorCategoryEnum.FinanceAndInvesting,
    description:
      "Beyond the exceptional staff!After encountering problems with Kajabi, we needed a new platform FAST, and one that would allow us to represent who we are as a company. The website design is sleek and intuitive, making it a breeze to navigate.",
    designation: "Real estate mastery",
    company: "Ceshkar Group",
    highlight: {
      main: "2k+",
      subtext: "Facebook followers",
    },
    avatar: `https://d502jbuhuh9wk.cloudfront.net/logos/6635015fca139e6991a897b4.png`,
    image: `${ASSETS_LINK}/graphy-web/nitinmodi2401_image.jpg`,
    href: "https://tomceshker.graphy.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.aiavatar]: { 
          testimony: true,
          stories: true,
        },
       
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: { 
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.IntegratePaymentGateway]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Laurel Archer",
    category: CreatorCategoryEnum.Academics,
    description:
      "I like all the options it has for Design, Marketing, and for selling Courses - I am excited about sharing my new home to the world.",
    designation: "Founder",
    company: "Laurel's Learning Lab",
    highlight: {
      main: "575",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/laurelarcher4128_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/laurelarcher4128_image.jpg`,
    href: "https://www.laurelslearninglab.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.aiavatar]: {
          testimony: false,
          stories: true,
        },
        
        
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.IntegratePaymentGateway]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  // {
  //   name: "Raghuram Natesan",
  //   category: CreatorCategoryEnum.Technology,
  //   description:
  //     "I believe that the features offered by Graphy are conducive to create a powerful learning experience.",
  //   designation: "Founder",
  //   company: "LifeSparsh",
  //   highlight: {
  //     main: "100+",
  //     subtext: "Instagram followers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/raghuramnatesan_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/raghuramnatesan_image.jpg`,
  //   href: "https://www.lifesparsh.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  {
    name: "Ebenezer Mamabolo",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
      "Its the best platform. Very simple and easy to master. Plus great support from the support team. I love Graphy.",
    designation: "Creator",
    company: "Monetizing Purpose",
    highlight: {
      main: "728",
      subtext: "Instagram followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/ebenezer2058_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/ebenezer2058_image.jpg`,
    href: "https://www.ebenezermamabolo.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.digitalProducts]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.telegramCommunity]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.aiavatar]: { 
          testimony: true,
          stories: true,
        },
       
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: { 
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },

      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  // {
  //   name: "Madhura Rajagopalan",
  //   category: CreatorCategoryEnum.Health,
  //   description:
  //     "It's affordable, user-friendly, has excellent backend support from the technical staff & gives a lot of control in the hands of the website owner to design the layout etc.",
  //   designation: "Yoga Coach",
  //   company: "Yoga with Madhura",
  //   highlight: {
  //     main: "380+",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/madhurarajagopalan9169_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/madhurarajagopalan9169_image.jpg`,
  //   href: "https://www.yogawithmadhura.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.WebsiteBuilder]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.IntegratePaymentGateway]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Sanjay Thakur",
  //   category: CreatorCategoryEnum.PersonalDevelopment,
  //   description:
  //     "A Complete package ideal for selling courses online, be it for school/college students or corporate executives and business owners.",
  //   designation: "Coach",
  //   company: "Master Koach",
  //   highlight: {
  //     main: "10K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/mkanak1933_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/mkanak1933_image.jpg`,
  //   href: "https://learning.masterkoach.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.MobileApp]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Nikhil Raibole",
  //   category: CreatorCategoryEnum.Business,
  //   description:
  //     "Graphy revolutionized my online business. Easy website creation, powerful marketing tools, seamless payment integration.",
  //   designation: "Founder",
  //   company: "GetInspire",
  //   highlight: {
  //     main: "800+",
  //     subtext: "Instagram followers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/nikhilraibole4800_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/nikhilraibole4800_image.jpg`,
  //   href: "https://nikhilraibole4800.graphy.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.IntegratePaymentGateway]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.MarketingTools]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Niladri Bihari",
  //   category: CreatorCategoryEnum.Other,
  //   description: `I was looking for a Digital Learning Platform for my Two Not-For-Profit initiatives but I didn't want to compromise on any of the advanced features of a modern LMS. Graphy was "THE" solution ticking all the checkboxes of our need.`,
  //   designation: "Trainer",
  //   company: "ISKCON Brahmapur",
  //   highlight: {
  //     main: "7K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/niladribiharinayak_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/niladribiharinayak_image.jpg`,
  //   href: "https://niladribiharinayak.graphy.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.WebsiteBuilder]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.SecureVideoStreaming]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Nishant Sharma",
  //   category: CreatorCategoryEnum.Business,
  //   description:
  //     "I like it very much there is always a scope for improvement, and I have been and will  continue to suggest the same",
  //   designation: "Founder",
  //   company: "Mentor Geeks",
  //   highlight: {
  //     main: "100+",
  //     subtext: "Linkedin followers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/nishantsharma9432_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/nishantsharma9432_image.jpg`,
  //   href: "https://www.mentorgeeks.in",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.MarketingTools]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Sachin Rao",
  //   category: CreatorCategoryEnum.Academics,
  //   description:
  //     "I was trying to compare with other similar products and when I felt this was better for selling courses online, I took it up. The support was Excellent.",
  //   designation: "Coach",
  //   company: "Cricket Coach Online",
  //   highlight: {
  //     main: "200+",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/sachinrao6295_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/sachinrao6295_image.jpg`,
  //   href: "https://www.cricketcoachonline.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.WebsiteBuilder]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.ChatCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "CA Rachana Ranade",
  //   category: CreatorCategoryEnum.Finance,
  //   description:
  //     "I've been using Graphy since Day 1 of my entrepreneurial journey. Its because of Graphy that I'm able to offer my courses in India & internationally. The platform's global payment options & mobile apps enabled me to connect with students worldwide",
  //   designation: "Founder",
  //   company: "Rachana Ranade",
  //   highlight: {
  //     main: "4.45M",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/carachana_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/carachana_image.jpg`,
  //   href: "https://www.rachanaranade.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.WebsiteBuilder]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.MobileApp]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Neeraj Arora",
  //   category: CreatorCategoryEnum.Business,
  //   description:
  //     "Graphy has got all the elements to make our Coaching & Online Courses business a success",
  //   designation: "Master Coach",
  //   company: "Skill91",
  //   highlight: {
  //     main: "800+ K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/skill91_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/skill91_image.jpg`,
  //   href: "https://www.skill91.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: true,
  //         stories: false,
  //       },

  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.SecureVideoStreaming]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Kundan Kishore",
  //   category: CreatorCategoryEnum.Finance,
  //   description:
  //     "Graphy has all the features required to sell courses online and create a good learning platform",
  //   designation: "Founder",
  //   company: "Kundan Kishore",
  //   highlight: {
  //     main: "186K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/kundankishore_avatar.png`,
  //   image: `${ASSETS_LINK}/graphy-web/kundankishore_image.jpg`,
  //   href: "https://www.kundankishore.in",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.MarketingTools]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.WebsiteBuilder]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Love Babbar",
  //   category: CreatorCategoryEnum.Academics,
  //   description:
  //     "Graphy is a platform that is feature-rich whilst being easy to use. The tools provide me with a lot of control with regard to Referrals, Course Content, & Analytics. Graphy has been the perfect partner for us.",
  //   designation: "Founder",
  //   company: "Code Help",
  //   highlight: {
  //     main: "533K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/lovebabbar4318_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/lovebabbar4318_image.jpg`,
  //   href: "https://www.thecodehelp.in",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.WebsiteBuilder]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.MobileApp]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.ChatCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Niranjan P",
  //   category: CreatorCategoryEnum.Other,
  //   description:
  //     "I'm amazed by the impact Graphy has had on my business. The professional design options and seamless integration of multimedia content have taken my courses to the next level.",
  //   designation: "Creator",
  //   company: "Niru's Calligraphy",
  //   highlight: {
  //     main: "46K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/niruscalligraphy6003_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/niruscalligraphy6003_image.jpg`,
  //   href: "https://niruscalligraphycourses.graphy.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.ChatCommunity]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  {
    name: "Harnoor Singh",
    category: CreatorCategoryEnum.Academics,
    description:
      "The quickest way to launch and sell your course. Trust me on this, you will be running a thriving business in no time.",
    designation: "Founder",
    company: "Singh in USA",
    highlight: {
      main: "1.04M",
      subtext: "YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/harnoorsingh1547_avatar.jpeg`,
    image: `${ASSETS_LINK}/graphy-web/harnoorsingh1547_image.jpg`,
    href: "https://singhinusa.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.webinar]: {
          testimony: true,
          stories: false,
        },
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.SecureVideoStreaming]: {
          testimony: true,
          stories: false,
        },
        [FeaturePageSlugEnum.MarketingTools]: {
          testimony: false,
          stories: true,
        },
        [FeaturePageSlugEnum.MobileApp]: {
          testimony: true,
          stories: false,
        },
      },
      pricing: false, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  // {
  //   name: "Murali Sundaram",
  //   category: CreatorCategoryEnum.PersonalDevelopment,
  //   description:
  //     "All I wanted was an app & membership feature to automate the process of onboarding students. Leaving me to focus on teaching without having to worry about the tech side of things. Graphy has given me just that.",
  //   designation: "Coach",
  //   company: "Unlimited Happyness",
  //   highlight: {
  //     main: "5.7K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/coachmurli_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/coachmurli_image.jpg`,
  //   href: "https://www.unlimitedhappyness.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "CA Neha Datta",
  //   category: CreatorCategoryEnum.PersonalDevelopment,
  //   description:
  //     "The platform's intuitive course builder, multimedia capabilities, and analytics have made creating immersive learning experiences effortless. Graphy is a game-changer for personal development courses.",
  //   designation: "Founder",
  //   company: "CA Neha Datta",
  //   highlight: {
  //     main: "150K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/canehadatta6479_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/canehadatta6479_image.jpg`,
  //   href: "https://canehadatta.ongraphy.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: false, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Sanchit Kalra",
  //   category: CreatorCategoryEnum.PersonalDevelopment,
  //   description:
  //     "Navigating through the platform and accessing its features is a breeze, even for someone who may not be tech-savvy.",
  //   designation: "Founder",
  //   company: "Be Your Best",
  //   highlight: {
  //     main: "538K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/sanchitkalra_avatar.jpeg`,
  //   image: `${ASSETS_LINK}/graphy-web/sanchitkalra_image.jpg`,
  //   href: "https://sanchitkalra.ongraphy.com",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.membership]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.digitalProducts]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [ProductPageSlugEnum.telegramCommunity]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.SecureVideoStreaming]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  // {
  //   name: "Sujata Dutta",
  //   category: CreatorCategoryEnum.Business,
  //   description:
  //     "Most user friendly platform that I have come across And loaded with features and benefits :)",
  //   designation: "Founder",
  //   company: "Designers Mastermind Hub",
  //   highlight: {
  //     main: "1.2K",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/sujatadutta4963_avatar.webp`,
  //   image: `${ASSETS_LINK}/graphy-web/sujatadutta4963_image.jpg`,
  //   href: "https://sujatadutta4963.spayee.com",
  //   showOn: {
  //     home: false,
  //     products: {
  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.MarketingTools]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.SecureVideoStreaming]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
  {
    name: "Brooke Harris",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
      "My website looks like it was professionally designed and the courses are laid out beautifully and easy for users to interact with and understand. The Graphy team has been super helpful, responsive and patient while guiding me through this process and helping me get my site and business launched. I'm so grateful this exists.",
    designation: "CEO @ Goodmylk",
    company: "Expander's Club",
    highlight: {
      main: "4k+",
      subtext: "Instagram followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/brookeharris_avatar.png`,
    image: `${ASSETS_LINK}/graphy-web/nitinmodi2401_image.jpg`,
    href: "https://www.expandersclub.com",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.aiavatar]: {
          testimony: false,
          stories: true,
        },
        
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.aiagent]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.aibrain]: {
          testimony: true,
          stories: true,
        },
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: true, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Kimberly Clark",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
        "Y'all, I'm obsessed with how Graphy puts people first! As someone who runs both webinars and a monthly course creation bootcamp on their platform, I'm continually blown away by how their team goes above and beyond with hands-on support for every creator. They don't just host courses - they're freaking invested in their partners' success and it shows in everything they do!",
    designation: "Founder",
    company: "Flawsome Media",
    highlight: {
      main: "6k",
      subtext: "LinkedIn Followers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/KimbelyClark_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/KimberlyClark_image.png`,
    href: "https://digitalentrepreneurlife.com/social",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: true, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "Bradley Thomson",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
        "From sales right through to design and follow-up graphy were brilliant. It was easy to get connected and the service was always excellent. I am so happy I chose graphy that I have placed a second business website with them as well.",
    designation: "Founder",
    company: "Foundation Co.",
    highlight: {
      main: "500",
      subtext: "Linkedin",
    },
    avatar: `${ASSETS_LINK}/graphy-web/BradleyThomson_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/BradleyThomson_image.png`,
    href: "https://bradthomson.graphy.com/",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: true, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  {
    name: "John Evans",
    category: CreatorCategoryEnum.PersonalDevelopment,
    description:
        "The customer service and relative ease of use are great...anything I can't figure out, my representative gets on the phone and helps me resolve. I'm also pleased with the quickness of sales and overall quality of the site and courses graphy helped me create. Additionally, they are consistently adding updates, new aids and marketing help and making improvements.",
    designation: "Founder",
    company: "Mister One Putt",
    highlight: {
      main: "25.3k",
      subtext: " YouTube subscribers",
    },
    avatar: `${ASSETS_LINK}/graphy-web/JohnEvans_avatar.jpg`,
    image: `${ASSETS_LINK}/graphy-web/JohnEvans_image.png`,
    href: "https://johnevans.graphy.com/",
    showOn: {
      home: true,
      products: {
        [ProductPageSlugEnum.courses]: {
          testimony: false,
          stories: true,
        },
        [ProductPageSlugEnum.membership]: {
          testimony: false,
          stories: true,
        },
      },
      features: {
        [FeaturePageSlugEnum.ChatCommunity]: {
          testimony: false,
          stories: true,
        },
      },
      pricing: true, // If it's false, we can skip the key also.
      stories: true,
    },
  },
  // {
  //   name: "Ankur Warikoo",
  //   category: CreatorCategoryEnum.Business,
  //   description:
  //     "Graphy is a truly all-in-one platform that covers every aspect of scaling my business seamlessly",
  //   designation: "Founder",
  //   company: "WebVeda",
  //   highlight: {
  //     main: "5.78 M",
  //     subtext: "YouTube subscribers",
  //   },
  //   avatar: `${ASSETS_LINK}/graphy-web/webveda_avatar.jpg`,
  //   image: `${ASSETS_LINK}/graphy-web/webveda_image.png`,
  //   href: "https://webveda.com/",
  //   showOn: {
  //     home: true,
  //     products: {
  //       [ProductPageSlugEnum.courses]: {
  //         testimony: true,
  //         stories: false,
  //       },

  //       [ProductPageSlugEnum.webinar]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //     },
  //     features: {
  //       [FeaturePageSlugEnum.SecureVideoStreaming]: {
  //         testimony: false,
  //         stories: true,
  //       },
  //       [FeaturePageSlugEnum.ThirdPartySupport]: {
  //         testimony: true,
  //         stories: false,
  //       },
  //     },
  //     pricing: true, // If it's false, we can skip the key also.
  //     stories: true,
  //   },
  // },
];



export const creatorStoriesPageData_en: CreatorStoriesPageDataType = {
  seoMeta: {
    title: "Creators who monetize their content - Graphy",
    description: "Graphy is a home to 1.5L+ creators who made a living out of their content. Start monetizing your content now. ",
    canonicalPath: ROUTE_PATHS.CREATOR_STORIES,
    countryCode: ""
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Let's create your",
        highlight: false,
      },
      {
        text: " online presence",
        highlight: true,
      },
    ],
    description:
      "Start your online business today by signing up with Graphy and unleashing your creativity!",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        actionType: CtaActionType.SignUp,
        text: "Start for free",
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.bw_creator_cards,
          },
        },
      },
    ],
  },
  creatorStoriesHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Creators,
    },
    title: [
      {
        text: "Inspiring",
        lineBreak: true,
      },
      {
        text: "Stories",
        highlight: true,
      },
    ],
    description:
      "Discover the power of Graphy through inspiring stories and journey to happiness and success",
    successStories: successStories,
  },
};

export const creatorStoriesPageData_us: CreatorStoriesPageDataType = {
  seoMeta: {
    title: "Creators who monetize their content - Graphy",
    description: "Graphy is a home to 1.5L+ creators who made a living out of their content. Start monetizing your content now. ",
    canonicalPath: ROUTE_PATHS.CREATOR_STORIES,
    countryCode: ""
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Let's create your",
        highlight: false,
      },
      {
        text: " online presence",
        highlight: true,
      },
    ],
    description:
      "Start your online business today by signing up with Graphy and unleashing your creativity!",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        actionType: CtaActionType.SignUp,
        text: "Start for free",
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.bw_creator_cards,
          },
        },
      },
    ],
  },
  creatorStoriesHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Creators,
    },
    title: [
      {
        text: "Inspiring",
        lineBreak: true,
      },
      {
        text: "Stories",
        highlight: true,
      },
    ],
    description:
      "Discover the power of Graphy through inspiring stories and journey to happiness and success",
    successStories: successStoriesUS,
  },
};